import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Modal } from 'bootstrap';

// Tambahkan deklarasi untuk intlTelInput dengan tipe yang lebih spesifik
declare var intlTelInput: {
  (element: HTMLElement, options?: {
    initialCountry?: string;
    separateDialCode?: boolean;
    loadUtilsOnInit?: boolean; // Gantikan utilsScript dengan loadUtilsOnInit
    // Tambahkan opsi lain sesuai kebutuhan
  }): any;
};
@Component({
  selector: 'app-account-phone-number',
  templateUrl: './account-phone-number.component.html',
  styleUrls: ['./account-phone-number.component.css']
})
export class AccountPhoneNumberComponent implements OnInit, AfterViewInit {
   @ViewChild('phoneInput') phoneInput!: ElementRef;
   @ViewChild('pesanModal') pesanModal!: ElementRef;

   step: 'phone' | 'otp' | 'register' | 'existing' = 'phone';
   mode: 'add' | 'edit' = 'add';
   
   phoneForm!: FormGroup;
   otpForm!: FormGroup;

   showLoginForm: boolean = true;
   submitted = false;
   errorMessage: string = '';
   // Tambahkan variabel untuk menyimpan instance intlTelInput
   private intlTelInputInstance: any;
 
   // Timer untuk OTP
   remainingTime = 180; // 3 menit (dalam detik)
   private countdownInterval: any;

   isLoading: boolean = false;

   no_wa:string = '';
   sts : string = '';


  constructor(
    private fb: FormBuilder, 
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    ) {
      this.initializeForms();
    }

       private initializeForms() {
         this.phoneForm = this.fb.group({
           phone: ['', [
             Validators.required, 
             Validators.pattern('^[0-9]{10,13}$') // Ensure that phone number is valid
           ]]
         });
   
         this.otpForm = this.fb.group({
           otp: ['', [
             Validators.required,
             Validators.pattern('^[0-9]{6}$') // Validasi OTP 6 digit
           ]]
         });
     
       }

   ngOnInit(): void {

  
    setTimeout(() => {
      this.initializePhoneInput();
    }, 50);
      
    this.mode = history.state.mode; // Mengatur mode berdasarkan state yang diterima
    if (this.mode === 'edit') {
      this.prefillPhoneNumber();
    }
    
   }


  private prefillPhoneNumber(): void {
    const userPhoneNumber = localStorage.getItem('user_wa'); // Ambil nomor telepon dari storage
    if (userPhoneNumber) {
      this.phoneForm.patchValue({ phone: userPhoneNumber });
      setTimeout(() => {
        if (this.intlTelInputInstance) {
          this.intlTelInputInstance.setNumber(userPhoneNumber);
        }
      }, 100);
    }
  }

     // Fungsi untuk memuat script intlTelInput secara dinamis

  
    // Fungsi untuk inisialisasi input telepon
    private initializePhoneInput() {
      if (this.phoneInput && (window as any).intlTelInput) {
        const input = this.phoneInput.nativeElement;
        
        // Hapus instance sebelumnya jika ada
        if (this.intlTelInputInstance) {
          this.intlTelInputInstance.destroy();
        }
  
        // Inisialisasi intlTelInput dengan opsi yang lebih lengkap
        this.intlTelInputInstance = intlTelInput(input, {
          initialCountry: 'id', 
          separateDialCode: true, 
          loadUtilsOnInit: true
        });
      }
    }

    onContinueWithPhone() {
      this.submitted = true;
      if (this.phoneForm.invalid) return;
  
      const countryData = this.intlTelInputInstance.getSelectedCountryData();
      const dialCode = countryData.dialCode;
      const phoneNumber = this.phoneForm.value.phone;
      this.no_wa = `+${dialCode}${phoneNumber.replace(/\D/g, '')}`;
  
      if (this.mode === 'add') {
        this.onSendOtp();
      } else if (this.mode === 'edit') {
        this.onSendOtp();
      }
    }

    getFormControl(form: FormGroup, controlName: string): AbstractControl | null {
      return form.get(controlName);
    }
    
    
    // Safely check if control has specific error
    hasError(form: FormGroup, controlName: string, errorType: string): boolean {
      const control = this.getFormControl(form, controlName);
      return control ? (this.submitted && control.hasError(errorType)) : false;
    }


    // Fungsi untuk format waktu (MM:SS)
    formatTime(seconds: number): string {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    }


    // Request OTP ulang
  onRequestOtpAgain(): void {
    this.remainingTime = 300; // Reset waktu 5 menit
    this.onSendOtp(); // Kirim OTP lagi
  }

  // Fungsi untuk memulai hitung mundur
  private startCountdown(): void {
    this.remainingTime = 300; // 5 menit
    clearInterval(this.countdownInterval); // Hentikan interval sebelumnya jika ada

    this.countdownInterval = setInterval(() => {
      if (this.remainingTime > 0) {
        this.remainingTime--;6
      } else {
        clearInterval(this.countdownInterval);
      }
    }, 1000); // Interval setiap detik
  }

    onSendOtp(): void {
      this.submitted = true;
    
      if (this.phoneForm.invalid) {
        return;
      }
    
       // Ambil data negara yang dipilih
       const countryData = this.intlTelInputInstance.getSelectedCountryData();
       const dialCode = countryData.dialCode; // Kode negara (misalnya "+62")
    
      const phoneNumber = this.phoneForm.value.phone;
    
       // Gabungkan kode negara dengan nomor telepon
       const fullPhoneNumber = `+${dialCode}${phoneNumber.replace(/\D/g, "")}`;
    
      
      this.isLoading = true;

      const userEmail = localStorage.getItem('user_email');
      if (!userEmail) return;

      this.authService.sendOtp2(fullPhoneNumber, userEmail).subscribe({
        next: (res) => {
          this.isLoading = false;
          this.submitted = false;
          this.no_wa = res.whatsapp_number;
          this.sts = res.status;
          this.step = 'otp'; // Pindah ke langkah OTP
          this.startCountdown(); // Mulai hitung mundur
        },
        error: (err) => {
          this.isLoading = false;
          this.errorMessage = 'Failed to send OTP. Please try again.';
          console.error(err);
        }
      });
    }

ngAfterViewInit(): void {
  const modalElement = this.pesanModal.nativeElement;

    // Tambahkan event listener untuk 'hide.bs.modal'
    modalElement.addEventListener('hide.bs.modal', () => {
        this.submitted = false;
        this.isLoading = false;
    });

    // Tambahkan event listener untuk 'hidden.bs.modal'
    modalElement.addEventListener('hidden.bs.modal', () => {
      this.submitted = false;
      this.isLoading = false;
    });
}
    
  // Verifikasi OTP
onVerifyOtp(): void {
  this.submitted = true;

  if (this.otpForm.invalid) {
    return;
  }

  const otpCode = this.otpForm.value.otp;
  // Ambil data negara yang dipilih
  const countryData = this.intlTelInputInstance.getSelectedCountryData();
  const dialCode = countryData.dialCode; // Kode negara (misalnya "+62")

  const phoneNumber = this.phoneForm.value.phone;

  // Gabungkan kode negara dengan nomor telepon
  const fullPhoneNumber = `+${dialCode}${phoneNumber.replace(/\D/g, "")}`;
  this.no_wa = fullPhoneNumber;
  this.isLoading = true;


  const userEmail = localStorage.getItem('user_email');
  if (!userEmail) return;

  if (this.sts ==='terdaftar')
  {
    const modalElement = this.pesanModal.nativeElement;
    const modal = new Modal(modalElement);
    modal.show();
  
  }
  else
  {
    this.authService.verifyOtp2(fullPhoneNumber, userEmail, otpCode ).subscribe({
      next: (res) => {

          this.submitted = false;
          this.isLoading = false;
          this.router.navigate(['/account']);
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = 'Invalid OTP or OTP has expired!';
        console.error(err);
      }
    });
  }



}

lanjut_simpan() {
  const otpCode = this.otpForm.value.otp;
  // Ambil data negara yang dipilih
  const countryData = this.intlTelInputInstance.getSelectedCountryData();
  const dialCode = countryData.dialCode; // Kode negara (misalnya "+62")

  const phoneNumber = this.phoneForm.value.phone;

  // Gabungkan kode negara dengan nomor telepon
  const fullPhoneNumber = `+${dialCode}${phoneNumber.replace(/\D/g, "")}`;
  this.no_wa = fullPhoneNumber;
  this.isLoading = true;

  const userEmail = localStorage.getItem('user_email');
  if (!userEmail) return;

  this.authService.verifyOtp2(fullPhoneNumber, userEmail, otpCode ).subscribe({
    next: (res) => {

        this.submitted = false;
        this.isLoading = false;
        // this.router.navigate(['/account']);
        window.location.href = '/account';
    },
    error: (err) => {
      this.isLoading = false;
      this.errorMessage = 'Invalid OTP or OTP has expired!';
      console.error(err);
    }
  });


}

kembali () {
  this.router.navigate(['/account']);
}

switchToWA(){
  this.step = 'phone';
}

}
